import React, { useState } from "react";
import { FileArchive } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";

const pad = (n) => String(n).padStart(2, "0");
const day = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const PERIODS = [
  { key: "all", label: "Tutto il periodo" },
  { key: "30d", label: "Ultimi 30 giorni" },
  { key: "month", label: "Mese corrente" },
  { key: "prev", label: "Mese scorso" },
  { key: "90d", label: "Ultimi 3 mesi" },
  { key: "year", label: "Anno corrente" },
  { key: "custom", label: "Personalizzato" },
];

const rangeFor = (key, from, to) => {
  const now = new Date();
  const y = now.getFullYear(), m = now.getMonth();
  switch (key) {
    case "30d": return [day(new Date(y, m, now.getDate() - 29)), day(now)];
    case "90d": return [day(new Date(y, m, now.getDate() - 89)), day(now)];
    case "month": return [day(new Date(y, m, 1)), day(now)];
    case "prev": return [day(new Date(y, m - 1, 1)), day(new Date(y, m, 0))];
    case "year": return [`${y}-01-01`, day(now)];
    case "custom": return [from || "0000-01-01", to || "9999-12-31"];
    default: return null;
  }
};

export const filterByPeriod = (quotes, range) => (range
  ? quotes.filter((q) => { const d = q.created_at ? day(new Date(q.created_at)) : ""; return d >= range[0] && d <= range[1]; })
  : quotes);

export default function ZipPeriodDialog({ open, onOpenChange, quotes, onConfirm }) {
  const [period, setPeriod] = useState("all");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const selected = filterByPeriod(quotes, rangeFor(period, from, to));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md w-[calc(100%-2rem)] rounded-xl" data-testid="zip-period-dialog">
        <DialogHeader>
          <DialogTitle>Scarica PDF in ZIP</DialogTitle>
          <DialogDescription>Scegli il periodo di creazione dei preventivi. Vale insieme ai filtri dell'elenco.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-2">
          {PERIODS.map((p) => (
            <button key={p.key} type="button" data-testid={`zip-period-${p.key}`} onClick={() => setPeriod(p.key)}
              className={`rounded-full border px-3 py-1.5 text-sm transition-colors ${period === p.key ? "border-primary bg-primary/10 text-primary font-semibold" : "border-slate-200 hover:bg-slate-50"}`}>
              {p.label}
            </button>
          ))}
        </div>
        {period === "custom" && (
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1"><Label className="text-xs">Dal</Label><Input type="date" data-testid="zip-period-from" value={from} onChange={(e) => setFrom(e.target.value)} /></div>
            <div className="space-y-1"><Label className="text-xs">Al</Label><Input type="date" data-testid="zip-period-to" value={to} onChange={(e) => setTo(e.target.value)} /></div>
          </div>
        )}
        <p data-testid="zip-period-count" className="text-sm text-slate-600">{selected.length} {selected.length === 1 ? "preventivo" : "preventivi"} da includere</p>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button data-testid="zip-period-confirm" disabled={!selected.length} onClick={() => onConfirm(selected)} className="gap-1.5">
            <FileArchive className="w-4 h-4" /> Scarica ZIP
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
